// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyCg4QIu-O7Eog6TtuEFGCpwYsURBiwIG5c",
    authDomain: "home-iot-202308.firebaseapp.com",
    databaseURL: "https://home-iot-202308.firebaseio.com",
    projectId: "home-iot-202308",
    storageBucket: "home-iot-202308.appspot.com",
    messagingSenderId: "1074098429084",
    appId: "1:1074098429084:web:db19fe8a4d9effb2"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
